import { baseQuery, generateQueryString } from '@/shared/api/utils';
import { REQUESTS_OPTIONS } from '@/shared/utils/constants.ts';

import { AssetRequest, AssetsRequest } from '@/shared/api/assets/assets.types.ts';
import { AssetBody, AssetCategory } from '@/shared/types/assets/assets.types.ts';
import { TagBodyAssetInfo } from '@/shared/types/assets/tags.types.ts';

export namespace AssetsAPINamespace {
  const client = baseQuery('NEW_API');

  export const getAll = async ({
    accessToken,
    accountResName,
    params = {},
    siteResName,
  }: AssetsRequest): Promise<AssetBody[]> => {
    let url = `/accounts/${accountResName}/sites/${siteResName}/assets`;
    const queryString = generateQueryString(params);

    if (queryString) url += `?${queryString}`;

    const { data } = await client.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return data.data.items;
  };

  export const getOne = async ({
    accessToken,
    accountResName,
    assetResName,
    siteResName,
  }: AssetRequest): Promise<AssetBody> => {
    const url = `/accounts/${accountResName}/sites/${siteResName}/assets/asset/${assetResName}`;

    const { data } = await client.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return data.data;
  };

  export const getAllCategoryTrees = async (
    accountResName: string,
    siteResName: string,
    accessToken: string,
  ): Promise<AssetCategory[]> => {
    const url = `/accounts/${accountResName}/sites/${siteResName}/assets/category-trees`;

    const result = await client.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return result.data.data.items;
  };

  export const getAllTags = async (
    accountResName: string,
    siteResName: string,
    accessToken: string,
  ): Promise<TagBodyAssetInfo[]> => {
    const url = `/accounts/${accountResName}/sites/${siteResName}/tags/availabilities?limit=${REQUESTS_OPTIONS.LIMIT_POINTS}`;

    const { data } = await client.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return data.data.items;
  };
}
